import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import customerDetailModel from '@/models/data-management/customer-detail'
import router from '@/router'
import store from '@/store'
import { onBeforeMount, reactive } from '@vue/composition-api'

export default function usePrivilegeHistory() {
  const { fetchPrivilegeHistoryList } = customerDetailModel()
  const {
    openWarningModal,
    openSuccessModal,
    openDefaultErrorModal,
  } = useValidationModal()

  const formData = reactive({
    customerId: 0,
    payload: [],
  })

  const loading = reactive({
    tableData: false,
  })

  const fields = [
    { key: 'no', label: 'ลำดับ' },
    { key: 'date', label: 'วันที่', sortable: true },
    { key: 'time', label: 'เวลา', sortable: true },
    { key: 'reward', label: 'ชื่อของรางวัล', sortable: true },
    { key: 'point', label: 'แต้มที่ใช้', sortable: true },
  ]

  const resolveDate = dateStr => {
    const date = new Date(dateStr)

    return `${fixedNum(date.getDate(), 2)}/${fixedNum(
      date.getMonth() + 1,
      2,
    )}/${date.getFullYear()}`
  }

  const resolveTime = dateStr => {
    const date = new Date(dateStr)

    return `${fixedNum(date.getHours(), 2)}:${fixedNum(
      date.getMinutes(),
      2,
    )} น.`
  }

  const fixedNum = (number, pad) => number.toString().padStart(pad, '0')

  const fetchPrivilegeHistoryListFunc = () => {
    loading.tableData = true
    fetchPrivilegeHistoryList.payload.Customer_Id = formData.customerId
    store
      .dispatch('api/apiRequest', fetchPrivilegeHistoryList)
      .then(resp => {
        const respData = resp.data.resp
        formData.payload = respData
      })
      .catch(err => {
        openDefaultErrorModal()
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  onBeforeMount(() => {
    if (!router.currentRoute.query.customerid) return
    formData.customerId = router.currentRoute.query.customerid
    fetchPrivilegeHistoryListFunc()
  })

  return {
    formData,
    fields,
    loading,
    resolveDate,
    resolveTime,
  }
}
